import React from 'react'

export default function LoginGateway() {

    
  return (
    <div>LoginGateway</div>
  )
}
